/*
 * @Description: 订单支付、支付成功
 * @Author: ywj
 * @Date: 2025-03-07 10:45:28
 * @LastEditTime: 2025-04-22 09:21:37
 * @LastEditors: ywj@originqc.com
 */
import React, { useState,useEffect } from "react";
import successIcon from '../../imgs/success.png'
import arrowIcon from '../../imgs/arrow.png'
import { useCountdown,timeToSeconds,secondsToTime} from '@/utils/index'
import './index.scss';

interface IOrderCard { 
  setTime?: (time: number) => void;
  payWays?: number,
  type: 'wait' | 'paid',
  isTimeOut?: boolean,
  setIsTimeOut?:(isTimeOut: boolean) => void;
  orderData: {
    totalAmount: string,
    qrcodeUrl: string,
    orderName: string,
    orderNo: string,
    payAmount: string,
    restTime: string,
    receiver: {
      id:number,
      name:string,
      tel:string,
      city:string,
      province:string,
      region:string,
      detailAddress:string,
    },
    billBase:{
      type:number,
      id:number,
      name:string,
      header:string,
    }

  } 
}

const successText: any = {
 
  0:'订单提交成功！请您尽快完成支付',
  1:'订单支付成功！我们尽快为您处理',
  2:'订单支付成功！我们尽快为您处理',
  3:'订单支付成功！我们尽快为您处理',
  4:'订单对公支付确认中！我们尽快为您处理',
}
const OrderCard: React.FC<IOrderCard> = (props) => {
  const [showDetail, setShowDetail] = useState(true);
  const [username, setUsername] = useState('');
  const [telphone,setTelephone] = useState('');
  const { orderData, setTime, payWays = 0, type, setIsTimeOut = false } = props;
  
  const { timeLeft, reset } = useCountdown(timeToSeconds(orderData?.restTime)); 

 // 监听 orderData?.restTime 变化，更新倒计时
  useEffect(() => {
    // debugger;
    if (Object.keys(orderData).length>0) { 
      const newTime: any = timeToSeconds(orderData.restTime??'00:00:00');
      reset(newTime);
    }
   
}, [orderData?.restTime]);
//处理名字和电话加密
  useEffect(() => {
    if (orderData && Object.keys(orderData).length > 0) { 
      
      if (orderData?.receiver?.name) { 
        const nameCopy = orderData?.receiver?.name;
        const encryptedName = nameCopy.length > 1 ?( nameCopy.length > 2?nameCopy[0] + '**':nameCopy[0] + '*' ): nameCopy;
        setUsername(encryptedName);
      }
      if (orderData?.receiver?.tel) { 
        const telCopy = orderData?.receiver?.tel;
        const tel = telCopy.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
        setTelephone(tel);
      }
    }
    // return () => { 
    //   reset();// 销毁定时器
    // }
  }, [orderData])
  useEffect(() => {
    console.log(timeLeft,'timeLeft')
    setTime && setTime(timeLeft);
    if(timeLeft <= 0) {
      setIsTimeOut&&setIsTimeOut(true);
    }
  }, [timeLeft]);

  const handleShowDetail = () => { 
    setShowDetail(!showDetail);
  }
  const payTypeObj: any = {
    1: '支付宝',
    2: '微信',
    3: '云闪付',
    4: '对公转账'
  }

  return <div className="order-card-content">
    <div className="top-content">
      <div className="order-card-left">
        <div className="order-card-left-content">
          <img src={successIcon} alt="" className="img" />

          <div className="content">
            <p className="title">{successText[payWays] ?? '订单支付成功！我们尽快为您处理'}</p>
            <p className="num">订单编号：{ orderData?.orderNo}</p>
            {type==='paid' ? <p className="tips">
              <span>支付金额：
                <span className="money">￥{orderData?.payAmount}</span>
              </span>
              <span className="way-text">支付方式：
                <span className="way">{ payTypeObj[payWays]??'/'}</span>
              </span>
            </p>
              : <p className="tips">请您在
                <span className="time">
                  {timeLeft ? secondsToTime(timeLeft) : '00:00:00'}
                  {/* {timeLeft ? timeLeft : '00:00:00'} */}
                </span>
                内完成支付，否则订单将被自动取消
            </p>}
          </div>
        </div>
      </div>
      <div className="order-card-right">
       {type==='wait'&& <p ><span className="title">应付金额：</span><span className="money">￥{orderData?.payAmount }</span></p>}
        <p className="detail-text" onClick={handleShowDetail}>订单详情 <img src={arrowIcon} alt="箭头" className={`${showDetail?"arrow-icon ":"rotate arrow-icon"}` }/></p>
      </div>
    </div>
    {showDetail && <div className="bottom-content">
      <p>商品名称：{ orderData?.orderName}</p>
      <p className="address-text">收货信息：<span>{username} </span>&nbsp;<span>{telphone}</span>&nbsp;
        {orderData?.receiver?.province}&nbsp;
        {orderData?.receiver?.city}&nbsp;
        {orderData?.receiver?.region}&nbsp;
        {orderData?.receiver?.detailAddress}&nbsp;
        {/* 合肥市 高新区 创新大道2800号创新产业园二期E2楼六层 */}
      </p>
      {orderData?.billBase && <p className="address-text">发票信息： {orderData?.billBase?.type === 3 ? '数电专用发票' : '数电普通发票'} {orderData?.billBase?.header}</p>}
    </div>}
  </div>;
}

export default OrderCard;
